import { actionHooksToActions, Session, UserAction, UserActionHook } from "types";

export type SessionActionHook = UserActionHook<Session>;

export const useSessionActions = (
  session: Session,
  actionHooks?: Array<SessionActionHook>
): { [id: string]: UserAction } => actionHooksToActions(session, actionHooks);
